import $ from 'jquery'

function actionsCarousel() {
	// Energy Campus Carousel - disable auto-play and manage prev item class
	
	function updatePrevNextClasses($carousel) {
		var $items = $carousel.find('.carousel-item');
		var $active = $carousel.find('.carousel-item.active');
		var activeIndex = $items.index($active);
		var totalItems = $items.length;
		
		// Remove prev/next classes from all items
		$items.removeClass('carousel-item-prev carousel-item-next');
		
		// Add to immediate previous item (with wrapping)
		var prevIndex = activeIndex - 1;
		if (prevIndex < 0) {
			prevIndex = totalItems - 1; // wrap to last item
		}
		$items.eq(prevIndex).addClass('carousel-item-prev');
		
		// Add to immediate next item (with wrapping)
		var nextIndex = activeIndex + 1;
		if (nextIndex >= totalItems) {
			nextIndex = 0; // wrap to first item
		}
		$items.eq(nextIndex).addClass('carousel-item-next');
	}
	
	$('.m-carousel--energy').each(function() {
		var $carousel = $(this);
		
		// Destroy any existing carousel instance
		$carousel.carousel('dispose');
		
		// Re-initialize with auto-play disabled
		$carousel.carousel({
			interval: false,
			ride: false
		});
		
		// Initialize prev/next classes on page load
		updatePrevNextClasses($carousel);
	});
	
	// Manage prev/next item classes after slide completes
	$('.m-carousel--energy').on('slid.bs.carousel', function (e) {
		updatePrevNextClasses($(this));
	});
}

export default actionsCarousel
